import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatterFile } from '@models/matter-file';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';

export interface UploadedFileEditModalDialogData {
	file: MatterFile;
}

@Component({
	selector: 'app-edit-modal',
	templateUrl: './edit-modal.component.html',
	styleUrls: ['./edit-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class UploadedFileEditModalComponent {
	public name: string;
	public docId: string;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: UploadedFileEditModalDialogData,
		private dialogRef: MatDialogRef<UploadedFileEditModalComponent>,
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
	) {
		this.name = data.file.name;
		this.docId = data.file.id;
	}

	save() {
		this.matterUploadedFilesDispatch.UpdateFileName(this.docId, this.name);
		this.dialogRef.close();
	}

	close() {
		this.dialogRef.close();
	}
}
